// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wise-report-container {
  width: 95vw;
  overflow: scroll;
  max-width: unset;
  overflow-x: hidden; }
  .wise-report-container .top .wise-img-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center; }
    .wise-report-container .top .wise-img-container .info-box {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 8%;
      left: 4%;
      color: white;
      background-color: #002c44bd;
      padding: 5px;
      border-radius: 4px; }
    .wise-report-container .top .wise-img-container .img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto; }
  .wise-report-container .wise-map-container,
  .wise-report-container .wise-img-container,
  .wise-report-container .line-chart {
    margin: 6px;
    height: 40vh;
    padding: 2px;
    border-radius: 4px;
    background-color: #0b1736;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; }
  .wise-report-container .NSG-map {
    height: 40vh; }
  .wise-report-container .line-chart {
    margin: 1rem auto 2px auto !important;
    height: 60vh;
    overflow: auto; }
  .wise-report-container .dataset-menu-wrapper {
    background-color: #0B1736;
    padding: 1rem;
    border-radius: 4px;
    width: 50%;
    margin: auto; }
    .wise-report-container .dataset-menu-wrapper strong {
      text-align: center;
      color: white;
      margin-bottom: 4px; }
  .wise-report-container .table-report-table {
    width: 100%;
    border-top: 1rem solid rgba(255, 255, 255, 0.382);
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center; }
    .wise-report-container .table-report-table .no-data {
      color: white;
      margin-top: 11%; }
  .wise-report-container .bottom {
    padding: 1.5rem;
    margin-top: -1rem;
    height: 500px; }
  .wise-report-container table td {
    font-size: 14px;
    padding: 1px 2px;
    height: 12px; }
  .wise-report-container .pagination-wrapper {
    position: relative;
    margin-top: 4px; }
    .wise-report-container .pagination-wrapper .pagination-controls {
      position: absolute;
      top: 1%;
      right: 0; }
      .wise-report-container .pagination-wrapper .pagination-controls .page-item .page-link {
        background-color: #002044;
        color: white; }
      .wise-report-container .pagination-wrapper .pagination-controls .active {
        font-weight: bold; }
    .wise-report-container .pagination-wrapper .pagination {
      --bs-pagination-active-border-color: unset; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/WISEReport/wise-report.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAA;EAJpB;IAOM,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAVzB;MAYQ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,YAAY;MACZ,2BAA2B;MAC3B,YAAY;MACZ,kBAAkB,EAAA;IArB1B;MAwBQ,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,YAAY,EAAA;EA3BpB;;;IAmCI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,4CAA4C,EAAA;EAxChD;IA0Ca,YAAY,EAAA;EA1CzB;IA4CI,qCAAqC;IACrC,YAAY;IACZ,cAAc,EAAA;EA9ClB;IAkDE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY,EAAA;IAtDd;MAyDI,kBAAkB;MAClB,YAAY;MACZ,kBAAkB,EAAA;EA3DtB;IAkEI,WAAW;IACX,iDAAiD;IACjD,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;IAvEvB;MA0EM,YAAY;MACZ,eAAe,EAAA;EA3ErB;IAgFI,eAAe;IACf,iBAAiB;IACjB,aAAa,EAAA;EAlFjB;IAuFM,eAAe;IACf,gBAAgB;IAChB,YAAY,EAAA;EAzFlB;IA8FI,kBAAkB;IAClB,eAAe,EAAA;IA/FnB;MAiGM,kBAAkB;MAClB,OAAO;MACP,QAAQ,EAAA;MAnGd;QAuGU,yBAAyB;QACzB,YAAY,EAAA;MAxGtB;QA6GQ,iBAAiB,EAAA;IA7GzB;MAkHM,0CAAoC,EAAA","sourcesContent":[".wise-report-container {\n  width: 95vw;\n  overflow: scroll;\n  max-width: unset;\n  overflow-x: hidden;\n  .top {\n    .wise-img-container {\n      position: relative;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      .info-box {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: absolute;\n        top: 8%;\n        left: 4%;\n        color: white;\n        background-color: #002c44bd;\n        padding: 5px;\n        border-radius: 4px;\n      }\n      .img {\n        max-width: 100%; \n        max-height: 100%; \n        width: auto; \n        height: auto; \n      }\n    }\n  }\n\n  .wise-map-container,\n  .wise-img-container,\n  .line-chart {\n    margin: 6px;\n    height: 40vh;\n    padding: 2px;\n    border-radius: 4px;\n    background-color: #0b1736;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  }\n  .NSG-map { height: 40vh; }\n  .line-chart {\n    margin: 1rem auto 2px auto !important;\n    height: 60vh;\n    overflow: auto;\n } \n\n .dataset-menu-wrapper {\n  background-color: #0B1736;\n  padding: 1rem;\n  border-radius: 4px;\n  width: 50%;\n  margin: auto;\n\n  strong {\n    text-align: center;\n    color: white;\n    margin-bottom: 4px;\n  }\n}\n \n  \n \n  .table-report-table {\n    width: 100%;\n    border-top: 1rem solid rgba(255, 255, 255, 0.382);\n    overflow: auto;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    .no-data {\n      color: white;\n      margin-top: 11%;\n    }\n  }\n\n  .bottom {\n    padding: 1.5rem;\n    margin-top: -1rem;\n    height: 500px;\n  }\n\n  table {\n    td {\n      font-size: 14px;\n      padding: 1px 2px; \n      height: 12px; \n    }\n  }\n\n  .pagination-wrapper {\n    position: relative;\n    margin-top: 4px;\n    .pagination-controls {\n      position: absolute;\n      top: 1%;\n      right: 0;\n\n      .page-item {\n        .page-link {\n          background-color: #002044;\n          color: white;\n        }\n      }\n\n      .active {\n        font-weight: bold;\n      }\n    }\n\n    .pagination {\n      --bs-pagination-active-border-color: unset;\n    }\n  }\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
